import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormGroup, Validators} from '@angular/forms';
import {isNumeric} from '../../../../../../../../../../validators/ControlValidators';

@Component({
  selector: 'shared-wysokosc',
  templateUrl: './wysokosc.component.html'
})

export class WysokoscComponent implements OnInit {

  language = window.navigator.language

  get WYSOKOSC() { return this.formularzUszkodzenia.controls.wysokosc }

  @Input()
  formularzUszkodzenia!: UntypedFormGroup;

  @Input()
  minimalnaWysokosc!: number;

  @Input()
  maksymalnaWysokosc!: number;

  ngOnInit(): void {
    this.formularzUszkodzenia.controls.wysokosc.setValidators([Validators.required,
      Validators.min(this.minimalnaWysokosc), Validators.max(this.maksymalnaWysokosc), isNumeric()]);
  }

}
